import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

// import styles-globalStyles
import globalStyles from './../../../styles/globalStyles';

// import Formik and Dependency
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

// import utils
import { logger } from './../../../utils/utils';

// import fragments { ...Tabs} , Select*, FormComment
import { AntTabs, AntTab, TabPanel, a11yProps } from './../../fragments/Tabs';
import SelectPersonalDataCategory from './../../fragments/SelectPersonalDataCategory';
import SelectPermissionLevel from './../../fragments/SelectPermissionLevel';
import SelectPermissionGroup from './../../fragments/SelectPermissionGroup';
import { FieldComment } from './../../fragments/FormComment';

/**
 * Style
 */
const useStyles = makeStyles((theme) => ({
  ...globalStyles(theme),
}));

// YUP: build validation schema of form forward issue
const validateForwardShape = {
  // issue-forwarding validation schema
  issue: Yup.object().shape({
    category_id: Yup.string().required(
      'กรุณาเลือกประเภทของข้อมูลบุคลที่ต้องการส่งต่อ'
    ),
    level: Yup.string().required('กรุณาเลือกระดับการดำเนินการที่ต้องการส่งต่อ'),
    permissionGroupFilter: Yup.string(),
  }),

  // comment validation schema
  comment: Yup.object().shape({
    detail: Yup.string().required('กรุณากรอกความคิดเห็น'),
  }),
};

const validateForwardIssueSchema = Yup.object().shape(validateForwardShape);

// /**
//  * FormForwardIssueDialog() (Component)
//  * @param {opject} prop
//  * @returns FormForwardIssueDialog
//  */
const FormForwardIssueDialog = React.memo(
  ({
    id,
    categoryId,
    level,
    permissionGroupFilter,
    open,
    onSubmit,
    onCancel,
  }) => {
    const classes = useStyles();

    logger('FormForwardIssueDialog render');

    const [isLoading, setLIsoading] = useState(false);
    // Tab - State
    const [antTabValue, setAntTabValue] = React.useState(0);

    // Tab - Handle change tab
    const handleChangeTab = (event, newValue) => {
      setAntTabValue(newValue);
    };

    // InitialVaue forward issueForwarding form
    const initialValues = {
      issue: {
        issue_id: id,
        category_id: categoryId,
        level: level,
        permissionGroupFilter: permissionGroupFilter
          ? permissionGroupFilter
          : '',
      },
      comment: {
        issue_id: id,
        issueCommentType_id: 0,
        receiverType: 1,
        detail: '',
      },
    };

    //
    const recieverTypeByTabIndex = [1, 0];

    // Form (of Formik) reference
    const formikRef = useRef(null);

    // Show forward issue form (Formik children)
    const showFormForwardIssue = ({
      values,
      setFieldValue,
      touched,
      errors,
    }) => {
      // ErrorNTouch = error and touched
      let isErrorNTouchIssue = errors.issue && touched.issue;
      let isErrorNTouchComment = errors.comment && touched.comment;
      return (
        <Form className={classes.formStyle}>
          <SelectPersonalDataCategory
            name="issue.category_id"
            label="ประเภทของข้อมูลส่วนบุคคลฯ ที่ต้องการส่งต่อ"
            isSelectAll={false}
            variant="outlined"
            disabled={isLoading}
          />
          <SelectPermissionLevel
            name="issue.level"
            excludeData={[8, 9]}
            variant="outlined"
            disabled={isLoading}
          />
          <SelectPermissionGroup
            label="ระบุกลุ่มผู้ดูแล-ดำเนินการที่ต้องการส่ง"
            name="issue.permissionGroupFilter"
            categoryId={values.issue.category_id}
            level={values.issue.level}
            variant="outlined"
            disabled={isLoading}
          />
          <AntTabs
            value={antTabValue}
            onChange={handleChangeTab}
            aria-label="simple tabs example"
          >
            <AntTab label="ความคิดเห็นภายใน" {...a11yProps(0)} disabled={isLoading} />
            <AntTab label="ตอบผู้แจ้งเหตุ" {...a11yProps(1)} disabled={isLoading} />
          </AntTabs>
          <FieldComment
            name="comment.detail"
            id="detail"
            label="เพิ่มความคิดเห็น"
            disabled={isLoading}
            touched={isErrorNTouchComment && touched.comment.detail}
            errors={isErrorNTouchComment && errors.comment.detail}
          />
        </Form>
      );
    };

    return (
      <div>
        <Dialog
          fullWidth
          maxWidth="md"
          open={open}
          onClose={onCancel}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">ส่งต่อเหตุละเมิด</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText>
              ส่งต่อเหตุละเมิดไปยังผู้ดำเนินการใน
              ประเภทข้อมูล/ระดับชั้น/ระบุกลุ่มผู้ดูแล-ดำเนินการที่ต้องการส่ง
            </DialogContentText>
            <Formik
              validationSchema={validateForwardIssueSchema}
              enableReinitialize={true}
              initialValues={initialValues}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(false);
                // Set null for select empty permissionGroupFilter
                values.issue.permissionGroupFilter = values.issue
                  .permissionGroupFilter
                  ? values.issue.permissionGroupFilter
                  : null;
                // Get receiverType from recieverTypeByTabIndex and assign to values
                values.comment.receiverType =
                  recieverTypeByTabIndex[antTabValue];
                // onSubmit
                (async () => {
                  if (onSubmit) {
                    !isLoading && setLIsoading(true);
                    // values are {issue, comment}
                    await onSubmit(values);
                    setLIsoading(false);
                  }
                })();
              }}
              innerRef={formikRef}
            >
              {(props) => showFormForwardIssue(props)}
            </Formik>
          </DialogContent>
          <DialogActions>
            {isLoading && (
              <Box m={3}>
                <CircularProgress size={30} className={classes.circularProgressLoadStyle} />
              </Box>
            )}
            <Box m={3}>
              <Button
                onClick={() => formikRef.current.submitForm()}
                variant="contained"
                color="primary"
                disabled={isLoading}
              >
                ตกลง
              </Button>
            </Box>
            <Box m={3}>
              <Button variant="contained" onClick={onCancel} color="default" disabled={isLoading}>
                ยกเลิก
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export { FormForwardIssueDialog };
